import { attr, belongsTo, hasMany } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';

const Availability = ApplicationRecord.extend({
  attrs: {
    postcode_prefix: attr(),
    courier: belongsTo({ type: 'couriers-couriers' }),
    allowed: attr(),
    delivery_options: hasMany({ type: 'couriers-delivery_options' }),
    early_dispatch: attr({ type: Boolean }),
    monday_available_couriers: attr(),
    tuesday_available_couriers: attr(),
    wednesday_available_couriers: attr(),
    thursday_available_couriers: attr(),
    friday_available_couriers: attr(),
    saturday_available_couriers: attr(),
    sunday_available_couriers: attr(),
    monday_default_courier: attr(),
    tuesday_default_courier: attr(),
    wednesday_default_courier: attr(),
    thursday_default_courier: attr(),
    friday_default_courier: attr(),
    saturday_default_courier: attr(),
    sunday_default_courier: attr(),
    createdAt: attr({ persist: false }),
    updatedAt: attr({ persist: false }),
  },
  static: {
    endpoint: '/availabilities',
    jsonapiType: 'couriers-availabilities',
  },
});

export default Availability;
